import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { motion } from 'framer-motion';
import { FAQ_ITEMS, CALENDLY_URL } from '@/data/mock';
import { CTAButton } from '@/components/shared/SharedComponents';
import SEOHead, { faqSchema } from '@/components/shared/SEOHead';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export default function FAQPage() {
  const { currentTheme: t } = useTheme();

  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      <SEOHead
        title="Preguntas Frecuentes (FAQ) | Motivy"
        description="Resuelve tus dudas sobre Motivy. Conoce nuestra plataforma de capital humano, FitRewards, MotiCare, salud mental y más."
        keywords="FAQ Motivy, preguntas frecuentes, plataforma capital humano, FitRewards, MotiCare"
        structuredData={faqSchema(FAQ_ITEMS)}
      />
      {/* Hero */}
      <section className="pt-28 lg:pt-36 pb-12" style={{ background: t.heroBg }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>
            Preguntas Frecuentes
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-lg" style={{ color: t.textSecondary }}>
            Resuelve tus dudas sobre Motivy y nuestra plataforma de capital humano.
          </motion.p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16" style={{ background: t.bg }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="rounded-xl border px-6 overflow-hidden"
                style={{ background: t.cardBg, borderColor: t.cardBorder }}
              >
                <AccordionTrigger
                  className="text-left text-base font-semibold py-5 hover:no-underline"
                  style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent
                  className="text-sm leading-relaxed pb-5"
                  style={{ color: t.textSecondary }}
                >
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Footer CTA */}
          <div className="text-center mt-12 p-8 rounded-xl border" style={{ background: t.cardBg, borderColor: t.cardBorder }}>
            <p className="text-lg font-semibold mb-4" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>
              ¿No encuentras lo que buscas?
            </p>
            <CTAButton text="Habla con nosotros" href={CALENDLY_URL} />
          </div>
        </div>
      </section>
    </div>
  );
}
